var moduleMap = {
	"./bootstrap": () => {
		return Promise.all([__webpack_require__.e(247), __webpack_require__.e(36), __webpack_require__.e(412), __webpack_require__.e(354), __webpack_require__.e(659), __webpack_require__.e(881), __webpack_require__.e(471), __webpack_require__.e(644), __webpack_require__.e(390), __webpack_require__.e(198), __webpack_require__.e(934), __webpack_require__.e(39)]).then(() => (() => ((__webpack_require__(90634)))));
	},
	"./AzureAd": () => {
		return Promise.all([__webpack_require__.e(247), __webpack_require__.e(36), __webpack_require__.e(354), __webpack_require__.e(881), __webpack_require__.e(471), __webpack_require__.e(644), __webpack_require__.e(390), __webpack_require__.e(198), __webpack_require__.e(599)]).then(() => (() => ((__webpack_require__(52599)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});